/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import styles from './LearnerTable.module.css';
import star from '../../../../assets/profile/Vector (5).png';

// Generic interfaces for modularity
interface Column<T> {
	header: string;
	key: keyof T | 'actions' | 'progress';
	render?: (item: T) => React.ReactNode;
	optional?: boolean;
}

interface ProgramTableProps<T> {
	title?: string;
	data: T[];
	columns: Column<T>[];
	itemsPerPage?: number;
	stripedRows?: boolean;
}

const LearnerTable = <T extends { id: string | number }>({
	title,
	data,
	columns,
	itemsPerPage = 5,
	stripedRows = false,
}: ProgramTableProps<T>) => {
	const [currentPage, setCurrentPage] = useState(1);
	useEffect(() => {
	setCurrentPage(1);
}, [data]);

	// Pagination Logic
	const totalPages = Math.ceil(data.length / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const currentData = data.slice(startIndex, startIndex + itemsPerPage);

	return (
		<div className={styles.container}>
			{title && (
				<div className={styles.headerSection}>
					<span className={styles.iconPlaceholder}>
						<img
							src={star}
							alt="icon"
							className={styles.iconImage}
						/>
					</span>
					<h2 className={styles.title}>{title.toUpperCase()}</h2>
				</div>
			)}

			<div className={styles.tableWrapper}>
				<table className={styles.table}>
					<thead>
						<tr>
							{columns.map((col, index) => (
								<th
									key={index}
									className={
										col.optional ? styles.optionalCol : ''
									}
								>
									{col.header}
								</th>
							))}
						</tr>
					</thead>

					<tbody className={styles.tableBody}>
						{currentData.map((item, rowIndex) => {
							let rowClass = styles.normalRow;

							if (stripedRows) {
								rowClass =
									rowIndex % 2 === 0
										? styles.greyRow
										: styles.whiteRow;
							}

							return (
								<tr key={item.id} className={rowClass}>
									{columns.map((col, colIndex) => (
										<td
											key={colIndex}
											className={
												col.optional
													? styles.optionalCol
													: ''
											}
										>
											{col.render
												? col.render(item)
												: (item[
														col.key as keyof T
													] as React.ReactNode)}
										</td>
									))}
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>

			<div className={styles.footer}>
				{totalPages > 1 && (
					<div className={styles.pagination}>
						{Array.from({ length: totalPages }, (_, i) => (
							<button
								key={i + 1}
								className={`${styles.pageBtn} ${currentPage === i + 1 ? styles.activePage : ''}`}
								onClick={() => setCurrentPage(i + 1)}
							>
								{i + 1}
							</button>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default LearnerTable;
